import global from '@/assets/js/global'
import axios from 'axios'

const path = 'backStageLogin2'

/*
 *  LOGIN
 */

// 登入
const post = async (body) => {
  const res = await axios.post(`${global.server}${path}`, body)
  return res.data
}

// 修改密碼
const put = async (body, token) => {
  const options = {
    headers: { authorization: token },
  }

  const res = await axios.put(`${global.server}${path}`, body, options)

  return res.data
}

export default {
  post,
  put,
}
